/* Custom Global v4 - Same styles as homepage, fix social proof placement + click fix */
(function(){
  'use strict';

  /* Skip homepage (has its own customs) */
  if(document.querySelector('.pc')) return;

  /* ── CSS ── */
  var css = document.createElement('style');
  css.textContent = [
    '.guinea-tag{position:absolute;bottom:.7rem;right:.7rem;display:flex;align-items:center;gap:.35rem;background:rgba(247,243,236,.92);backdrop-filter:blur(4px);padding:.3rem .6rem;border-radius:2px;font-family:var(--font-u,sans-serif);font-size:.58rem;font-weight:500;letter-spacing:.08em;text-transform:uppercase;color:var(--guinea-grn,#009460);pointer-events:none;z-index:2}',
    '.mini-flag{display:flex;height:7px;width:12px;border-radius:1px;overflow:hidden;flex-shrink:0}',
    '.mini-flag span{flex:1 1 0%}',
    '.pbadge{position:absolute;top:.7rem;left:.7rem;font-family:var(--font-u,sans-serif);font-size:.6rem;font-weight:500;letter-spacing:.1em;text-transform:uppercase;padding:.28rem .65rem;border-radius:2px;pointer-events:none;z-index:2}',
    '.pb-promo{background:rgb(240,180,41);color:#1a1712}',
    '.pb-out{background:rgba(26,23,18,.45);color:var(--cream,#f7f3ec)}',
    '.pb-pop{background:rgb(206,32,32);color:var(--cream,#f7f3ec)}',
    '.pb-new{background:rgb(45,122,58);color:var(--cream,#f7f3ec)}',
    '.pb-exc{background:linear-gradient(135deg,var(--guinea-red),var(--guinea-grn));color:#fff}',
    '.social-proof-row{font-family:var(--font-u,sans-serif);font-size:.62rem;letter-spacing:.05em;color:rgba(26,23,18,.4);margin-bottom:.18rem;display:flex;align-items:center;gap:.3rem}',
    '.social-proof-row .dot{width:5px;height:5px;border-radius:50%;background:var(--guinea-grn,#009460);flex-shrink:0;animation:dotPulse 2s infinite}',
    '@keyframes dotPulse{0%,100%{opacity:.4}50%{opacity:1}}',
    '.social-proof-row .dot.dot-urgent{background:#cc2020!important}',
    '.card__badge{display:none!important}',
    '.card-wrapper:has(.pb-out) .card__media img:first-child{filter:grayscale(40%)!important;opacity:.7!important}',
    '.cg-img-link{position:absolute!important;top:0!important;left:0!important;width:100%!important;height:100%!important;z-index:3!important;display:block!important;pointer-events:auto!important}',
    '.cg-toast{position:fixed;bottom:20px;left:20px;background:#fff;border-radius:8px;box-shadow:0 4px 20px rgba(0,0,0,.15);padding:12px 16px;display:flex;align-items:center;gap:10px;z-index:9999;transform:translateY(120%);transition:transform .4s ease;max-width:340px;font-size:13px}',
    '.cg-toast.show{transform:translateY(0)}',
    '.cg-toast strong{color:var(--guinea-grn,#009460)}',
    '.cg-toast .t-time{font-size:11px;color:#999;margin-top:2px}'
  ].join('\n');
  document.head.appendChild(css);

  var spMessages = [
    '{n} achet\u00e9s cette semaine',
    '{n} vendus ce mois',
    '{n} personnes regardent ce produit',
    'Best-seller \u00b7 Tr\u00e8s demand\u00e9',
    'Stocks limit\u00e9s \u00b7 Importation exclusive',
    'Derni\u00e8res pi\u00e8ces disponibles',
    '{n} vendus cette semaine'
  ];

  function randomSP(){
    var msg = spMessages[Math.floor(Math.random()*spMessages.length)];
    if(msg.includes('{n}')) msg = msg.replace('{n}', Math.floor(Math.random()*35)+5);
    return msg;
  }

  var cities = ['Guin\u00e9e','Conakry'];
  var flagHTML = '<div class="mini-flag"><span style="background:var(--guinea-red,#ce1126)"></span><span style="background:var(--guinea-yel,#fcd116)"></span><span style="background:var(--guinea-grn,#009460)"></span></div>';

  /* ── COLLECTION PAGES ── */
  function enhanceCollection(){
    var cards = document.querySelectorAll('.card-wrapper');
    if(!cards.length) return;

    cards.forEach(function(card){
      if(card.dataset.cgDone) return;
      card.dataset.cgDone = '1';

      var media = card.querySelector('.card__media');

      /* Flag on image */
      if(media){
        var flag = document.createElement('div');
        flag.className = 'guinea-tag';
        flag.innerHTML = flagHTML + cities[Math.floor(Math.random()*cities.length)];
        media.appendChild(flag);
      }
      /* Clickable overlay on image */
      if(media){
        var link = card.querySelector('.card__heading a');
        if(!link) link = card.querySelector('a');
        if(link){
          var overlay = document.createElement('a');
          overlay.href = link.href;
          overlay.className = 'cg-img-link';
          overlay.setAttribute('aria-label', link.textContent.trim());
          media.appendChild(overlay);
        }
      }

      /* Badge on image */
      var priceEl = card.querySelector('.price');
      var isSoldOut = priceEl && priceEl.classList.contains('price--sold-out');
      var isOnSale = priceEl && priceEl.classList.contains('price--on-sale');

      if(media){
        var badge = document.createElement('span');
        if(isSoldOut){
          badge.className = 'pbadge pb-out';
          badge.textContent = '\u00c9puis\u00e9';
          media.appendChild(badge);
        } else if(isOnSale){
          badge.className = 'pbadge pb-promo';
          badge.textContent = 'Promo';
          media.appendChild(badge);
        } else {
          var r = Math.random();
          if(r < 0.2){
            badge.className = 'pbadge pb-pop';
            badge.textContent = 'Populaire';
            media.appendChild(badge);
          } else if(r < 0.35){
            badge.className = 'pbadge pb-new';
            badge.textContent = 'Nouveau';
            media.appendChild(badge);
          } else if(r < 0.45){
            badge.className = 'pbadge pb-exc';
            badge.textContent = 'Exclusif';
            media.appendChild(badge);
          }
        }
      }

      /* Social proof - inject in the SECOND card__content > card__information (visible one outside card__inner) */
      var cardEl = card.querySelector('.card');
      if(cardEl){
        var allContents = cardEl.querySelectorAll(':scope > .card__content');
        var visibleContent = null;
        for(var i=0; i<allContents.length; i++){
          if(allContents[i].offsetHeight > 10){
            visibleContent = allContents[i];
            break;
          }
        }
        if(!visibleContent && allContents.length > 1) visibleContent = allContents[allContents.length-1];
        
        if(visibleContent){
          var info = visibleContent.querySelector('.card__information');
          if(info){
            var sp = document.createElement('div');
            sp.className = 'social-proof-row';
            sp.innerHTML = '<span class="dot"></span>' + randomSP();
            info.appendChild(sp);
          }
        }
      }
    });
  }

  /* ── PRODUCT PAGE ── */
  function enhanceProduct(){
    var form = document.querySelector('form[action*="/cart/add"]');
    if(!form) return;
    if(document.querySelector('.cg-product-done')) return;

    var marker = document.createElement('div');
    marker.className = 'cg-product-done';
    marker.style.display = 'none';
    document.body.appendChild(marker);

    /* Flag near product title */
    var titleEl = document.querySelector('.product__title');
    if(titleEl && !titleEl.querySelector('.guinea-tag')){
      var flag = document.createElement('span');
      flag.className = 'guinea-tag';
      flag.style.position = 'relative';
      flag.style.bottom = 'auto';
      flag.style.right = 'auto';
      flag.style.display = 'inline-flex';
      flag.style.marginLeft = '8px';
      flag.style.pointerEvents = 'none';
      flag.innerHTML = flagHTML + 'Guin\u00e9e';
      titleEl.appendChild(flag);
    }

    /* Social proof under price */
    var priceEl = document.querySelector('.price');
    if(priceEl && !priceEl.parentElement.querySelector('.social-proof-row')){
      var sp1 = document.createElement('div');
      sp1.className = 'social-proof-row';
      sp1.style.marginTop = '6px';
      sp1.innerHTML = '<span class="dot dot-urgent"></span>' + Math.floor(Math.random()*20+5) + ' personnes regardent ce produit';
      priceEl.parentElement.insertBefore(sp1, priceEl.nextSibling);

      var sp2 = document.createElement('div');
      sp2.className = 'social-proof-row';
      sp2.innerHTML = '<span class="dot"></span>' + randomSP();
      sp1.parentElement.insertBefore(sp2, sp1.nextSibling);
    }

    /* FOMO bar under add-to-cart */
    var addBtn = form.querySelector('[name="add"], .product-form__submit');
    if(addBtn){
      var fomo = document.createElement('div');
      fomo.className = 'social-proof-row';
      fomo.style.marginTop = '10px';
      fomo.style.fontSize = '.7rem';
      var n = Math.floor(Math.random()*25+8);
      fomo.innerHTML = '<span class="dot"></span>\uD83D\uDD25 ' + n + ' personnes ont achet\u00e9 ce produit ces derni\u00e8res 24h';
      addBtn.parentElement.appendChild(fomo);
    }
  }

  /* ── FOMO Toast ── */
  function initToast(){
    var _fomoNames=['Aminata','Fatoumata','Mariama','Aissatou','Kadiatou','Fanta','Oumou','Dj\u00e9n\u00e9ba','Hawa','Nana','Binta','Safiatou','Maimouna','Ramatoulaye','Dienaba','Khady','Adama','Awa','Coumba','Dado','Djeneba','Fatou','Kadia','Mariam','N\u00e9n\u00e9','Rama','Safi','Sira','Tata','Yaye','A\u00efcha','Bintou','Diari\u00e9tou','Fily','Kadija','Mamou','Nafi','Rokia','Salimata','Tenin','A\u00efssata','Diaraye','Fatouma','Halimatou','Kankou','Mabinty','Nabou','N\u00e8n\u00e8','Salimatou','Yacine','Abibatou','Asmaou','Diariatou','Gnima','Hadja','Kesso','Lala','Mami','Nant\u00e8nin','Absa','Arame','Bousso','Codou','Daba','Diary','Gnilane','Ina','Jabou','Kin\u00e9','Lissa','Maguette','Ndeye','Nogaye','Oumy','Penda','Rokhaya','Seynabou','Tening','Yand\u00e9','Adjaratou','Astan','Banna','Cir\u00e9','Diahoumba','Djamilatou','Kadidja','Macir\u00e9','Nassira','Pili','Rabia','Saran','Talata','Wor\u00e9','Y\u00e9ro','Mamadou','Ibrahima','Ousmane','Moussa','Abdoulaye','Alpha','Boubacar','Cheick','Diallo','Fod\u00e9','Amadou','Baba','Cellou','Daouda','Elhadj','Habib','Issa','Karamo','Lamine','Mady','Naby','Omar','Path\u00e9','S\u00e9kou','Thierno','Youssouf','Abdoul','Aliou','Bailo','Demba','Facinet','Gnaly','Hamidou','Idrissa','Kaba','Lansana','Mohamed','Nounk\u00e9','Oumar','Papa','Saidou','Tidiane','Yaya','Aboubacar','Alassane','Hamza','Ismael','Lanseni','Mamady','Nfaly','Souleymane','Marie','Sophie','Camille','Julie','L\u00e9a','Emma','Chlo\u00e9','Manon','Sarah','Laura','Pauline','Marine','Charlotte','Ana\u00efs','Clara','In\u00e8s','Louise','Alice','Jade','Zo\u00e9','Lucie','Margaux','Oc\u00e9ane','Mathilde','Cl\u00e9mence','Valentine','Juliette','\u00c9lodie','Audrey','C\u00e9line','St\u00e9phanie','Nathalie','Caroline','Sandrine','Isabelle','Virginie','Delphine','Florence','B\u00e9atrice','Monique','Thomas','Nicolas','Julien','Pierre','Antoine','Alexandre','Maxime','Romain','Florian','Quentin','K\u00e9vin','J\u00e9r\u00e9my','David','S\u00e9bastien','Laurent','Christophe','Philippe','Fr\u00e9d\u00e9ric','Guillaume','Beno\u00eet','Fatima','Yasmine','Amina','Layla','Nadia','Samira','Leila','Soraya','Djamila','Zineb','Rachida','Karima','Malika','Na\u00efma','Safia','Hafsa','Meryem','Salma','Imane','Lina','Karim','Youssef','Mehdi','Rachid','Samir','Khalid','Hassan','Nassim','Bilal','Sofiane','Gnalen','Hadiatou','Kad\u00e9','Lancei','Nant\u00e9nin','Ramata','Sita','Tamba','Woury','Y\u00e9li','Zeinab','Bangaly','Cont\u00e9','Diakit\u00e9','Facely','Gbessay','Hady','Ibro','Jeannot','Kerfala','Lounc\u00e9ny','Mouctar','Nouhan','Sory','Vieux','Yakhouba','Zenab','A\u00efssatou','Billo','Damou','\u00c9liane','Finda','H\u00e9l\u00e8ne','Ilyass','Jos\u00e9phine','Kadidia','Lamissa','Mamoudou','Noumouk\u00e9','Oul\u00e9ye','Christelle','Sandra','Patricia','V\u00e9ronique','Sylvie','Catherine','Brigitte','Dominique','Fran\u00e7oise','Josiane','Annick','Martine','Mich\u00e8le','Nicole','Pascale','R\u00e9gine','Th\u00e9r\u00e8se','Yvette','Claudine','Danielle','Sefako','Moussokoro','Dj\u00e9n\u00e9bou','Kandia','Doussou','Korotoumou','Sanaba','T\u00e9n\u00e9ba','Bafing','S\u00e9kouba','Nansady','K\u00e9moko','Fod\u00e9ba','Sidiki','Kanfory','Bangali','Fac\u00e9ly','Mandjou','Soriba','Lancin\u00e9','Christiane','Bernadette','Jacqueline','Genevi\u00e8ve','Colette','Odette','Simone','Germaine','Ren\u00e9e','Lucienne','Priscilla','Angela','Jessica','Rebecca','Melissa','Jennifer','Stephanie','Christina','Michelle','Amanda','Aminatou','Djelo','K\u00e9ita','Nabyla','Ouleymatou','Ramatou','Bourama','Cond\u00e9','Doumbouya','Gbamou','Haidara','Ifono','Jeannette','Kourouma','Loua','Mansar\u00e9','Nab\u00e9','Onivogui','Povogui','Sagno','Tolno','Zoumanigui','B\u00e9avogui'];
var _fomoCities=['Paris','Lyon','Marseille','Toulouse','Bordeaux','Lille','Nantes','Strasbourg','Montpellier','Nice','Rennes','Toulon','Grenoble','Dijon','Angers','N\u00eemes','Saint-\u00c9tienne','Clermont-Ferrand','Le Havre','Aix-en-Provence','Brest','Tours','Amiens','Limoges','Metz','Perpignan','Besan\u00e7on','Orl\u00e9ans','Rouen','Mulhouse','Caen','Nancy','Avignon','Poitiers','Versailles','Pau','La Rochelle','Calais','Dunkerque','Valence','Colmar','Troyes','Chamb\u00e9ry','Lorient','Bayonne','Chartres','B\u00e9ziers','Ajaccio','Arles','Bourges','Cannes','Saint-Malo','\u00c9vry','Cr\u00e9teil','Bobigny','Cergy','Meaux','Melun','Pontoise','Saint-Denis','Neuilly-sur-Seine','Boulogne-Billancourt','Montreuil','Vitry-sur-Seine','Aubervilliers','Pantin','Ivry-sur-Seine','Nanterre','Colombes','Courbevoie','Sarcelles','Argenteuil','Aulnay-sous-Bois','\u00c9pinay-sur-Seine','Bondy','Noisy-le-Grand','Drancy','Villepinte','Sevran','Rosny'];
var _fomoProducts=['Beurre de Karit\u00e9','Savon Noir','Huile de Coco Vierge','Filet Exfoliant'];
var _fomoTimes=['il y a 2 min','il y a 3 min','il y a 5 min','il y a 8 min','il y a 12 min','il y a 15 min','il y a 18 min','il y a 22 min','il y a 25 min','il y a 30 min','il y a 35 min','il y a 40 min','il y a 45 min','il y a 1h','il y a 1h30','il y a 2h','il y a 3h'];
function _pick(a){return a[Math.floor(Math.random()*a.length)]}
var toastData=[];(function(){for(var i=0;i<50;i++){toastData.push({name:_pick(_fomoNames),city:_pick(_fomoCities),product:_pick(_fomoProducts),time:_pick(_fomoTimes)})}})()

    var toast = document.createElement('div');
    toast.className = 'cg-toast';
    document.body.appendChild(toast);

    var idx = 0;
    function showToast(){
      var d = toastData[idx % toastData.length];
      toast.innerHTML = '<div><strong>' + d.name + '</strong> de ' + d.city + '<br><span style="color:#555">' + d.product + '</span><div class="t-time">' + d.time + '</div></div>';
      toast.classList.add('show');
      setTimeout(function(){
        toast.classList.remove('show');
        idx++;
        setTimeout(showToast, 45000 + Math.random()*30000);
      }, 5500);
    }
    setTimeout(showToast, 30000);
  }

  /* ── Product recommendations observer ── */
  function watchRecommendations(){
    var target = document.querySelector('product-recommendations, .product-recommendations, [data-section-type="product-recommendations"]');
    if(!target) return;
    new MutationObserver(function(){ enhanceCollection(); }).observe(target, {childList:true, subtree:true});
  }

  /* ── Init ── */
  function init(){
    var path = window.location.pathname;
    if(path.includes('/collections')) enhanceCollection();
    if(path.includes('/products/')){
      enhanceProduct();
      watchRecommendations();
    }
    initToast();
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();